/**
 * ADR-026 scenario F — the "Wat → Wanneer → Klaar" tray on the week page.
 * heute's lesson, ported as a mechanism: the ease is the defaults layer
 * (a tile carries its usual time), the bounded chips ("every list ends")
 * and a button that states the resolved instant. Client-safe module: no
 * server imports. Labels are the family's own words; the chosen title is
 * stored verbatim and categorised by the deterministic keyword categorizer.
 */

export type ActivityPreset = {
	key: string
	label: string
	/** the usual clock time for this activity, "HH:MM" */
	time: string
	emoji: string
}

export const ACTIVITY_PRESETS: readonly ActivityPreset[] = [
	{ key: 'kapper', label: 'Kapper', time: '10:00', emoji: '💇' },
	{ key: 'huisarts', label: 'Huisarts', time: '09:30', emoji: '🩺' },
	{ key: 'fysio', label: 'Fysio', time: '11:00', emoji: '🤸' },
	{ key: 'koffie', label: 'Koffie', time: '10:30', emoji: '☕' },
	{ key: 'wandelen', label: 'Wandelen', time: '14:00', emoji: '🚶' },
	{ key: 'bezoek', label: 'Bezoek', time: '15:00', emoji: '🌷' },
	{ key: 'eten', label: 'Samen eten', time: '18:00', emoji: '🍽' },
	{ key: 'stal', label: 'Naar de stal', time: '10:15', emoji: '🐴' },
] as const

export const DEFAULT_TIME = '14:00'

/** The bounded time chips (buttons only — every list ends). */
export const TIME_CHIPS = [
	'09:00',
	'09:30',
	'10:00',
	'10:30',
	'11:00',
	'12:30',
	'14:00',
	'15:00',
	'16:00',
	'18:00',
	'19:30',
] as const

/** How far ahead the tray plans: today + this many days. */
export const TRAY_HORIZON_DAYS = 14

const DOW_NL = ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'] as const

/** 'YYYY-MM-DD' → 'di 23 sep' (noon UTC keeps the Amsterdam date in CET/CEST). */
export function dayChipLabel(dateKey: string, todayKey: string): string {
	const d = new Date(`${dateKey}T12:00:00Z`)
	const month = new Intl.DateTimeFormat('nl-NL', {
		timeZone: 'Europe/Amsterdam',
		month: 'short',
	})
		.format(d)
		.replace('.', '')
	const base = `${DOW_NL[d.getUTCDay()]} ${d.getUTCDate()} ${month}`
	if (dateKey === todayKey) return `vandaag (${base})`
	return base
}

export function addDays(dateKey: string, days: number): string {
	const d = new Date(`${dateKey}T12:00:00Z`)
	d.setUTCDate(d.getUTCDate() + days)
	return d.toISOString().slice(0, 10)
}

export function trayDayKeys(todayKey: string): string[] {
	return Array.from({ length: TRAY_HORIZON_DAYS + 1 }, (_, i) =>
		addDays(todayKey, i),
	)
}
